import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { stockApi } from "@/lib/stock.api";
import { queryKeys } from "@/lib/query-keys";

export function useUpdateStockArticleMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      id,
      data,
    }: {
      id: number;
      data: Partial<{
        name: string;
        unit: string;
        defaultSellingPrice: number;
        defaultSupplierPrice: number;
        minLevel: number;
      }>;
    }) => stockApi.update(id, data).then((r) => r.data),
    onSuccess: () => {
      toast.success("Article modifié.");
      queryClient.invalidateQueries({ queryKey: queryKeys.stock() });
    },
  });
}
